import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-product-man-tranlsations',
  templateUrl: './product-man-tranlsations.component.html',
  styleUrls: ['./product-man-tranlsations.component.css']
})
export class ProductManTranlsationsComponent implements OnInit {

  languages = [
    "serbain",
    "english"
  ];

  terms = [
    "greyhound",
    "race",
    "ticket",
    "winner",
    "place",
    "show",
    "double",
    "treble",
    "total12",
    "total123",
    "Won",
    "Lost"
  ]

  constructor() { }

  displayedColumns: string[] = ['Term', 'Translation','$$edit'];
  dataSource = USER_INFO; 

  ngOnInit(): void {
  }

}


const USER_INFO = [
  {Term: "Greyhound", Translation: "Trke pasa"},
  {Term: "Ticket", Translation: "Tiket"},
  {Term: "Trka", Translation: "Race"},
  {Term: "Winner", Translation: "Pobednik"},
  {Term: "Place", Translation: "U dva"},
  {Term: "Show", Translation: "Trifecta"},
];


